import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import LabelWrapper from 'components/Common/LabelWrapper';
import { useRole } from 'components/Hooks/UserHooks';
import { SYSTEM_CONFIG_KEY } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { getConfiguration, putConfiguration } from "../../../store/thunks";

interface ModalPromptProps {
    isOpen: boolean;
    onClose: () => void;
}

const ModalPrompt = ({ isOpen = false, onClose = () => { } }: ModalPromptProps) => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [condition, setCondition] = useState<{ generate_prompt: string, check_prompt: string, blocked_sites: string } | null>(null);


    const handleSave = async () => {
        try {
            if (isSaving) {
                return;
            }
            setIsSaving((_prev) => true);
            const _config = {
                configs: [
                    {
                        key: SYSTEM_CONFIG_KEY.NEWS_V2_GENERATE_PROMPT,
                        value: String(condition?.generate_prompt ?? ''),
                        is_active: 1,
                    },
                    {
                        key: SYSTEM_CONFIG_KEY.NEWS_V2_CHECK_PROMPT,
                        value: String(condition?.check_prompt ?? ''),
                        is_active: 1,
                    },
                    {
                        key: SYSTEM_CONFIG_KEY.NEWS_V2_BLOCKED_SITES,
                        value: String(condition?.blocked_sites ?? ''),
                        is_active: 1,
                    },
                ]
            };
            const response: any = await putConfiguration(_config);
            setIsSaving((_prev) => false);
            if (response?.code === 200) {
                toast(t("The process has been completed."), CONFIG_OPTION_TOAST_NORMAL);
                handleClose();
            } else {
                toast(response?.message || response, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsSaving((_prev) => false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const handleGetConfig = async () => {
        try {
            const response: any = await getConfiguration();
            if (response?.code === 200) {
                const _configs = response?.data?.list || [];
                const data = {
                    generate_prompt: _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_V2_GENERATE_PROMPT)?.value || '',
                    check_prompt: _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_V2_CHECK_PROMPT)?.value || '',
                    blocked_sites: _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_V2_BLOCKED_SITES)?.value || '',
                }
                setCondition((_prev: any) => ({ ..._prev, ...data }));
            }
        } catch (error) {
            return error;
        }
    };

    const handleClose = () => {
        setCondition((_prev: any) => null);
        onClose();
    };

    useEffect(() => {
        if (isOpen) {
            handleGetConfig();
        }
    }, [isOpen]);

    return (
        <React.Fragment>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="lg"
                scrollable={false}
            >
                <ModalHeader toggle={handleClose}>
                    <>{t("Config Generate")}</>
                </ModalHeader>
                <ModalBody className="pt-2">
                    <Row>
                        {isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_V2, userPermissions) && (
                            <Col lg={12}>
                                <CardBody className="pt-3">
                                    <Row>
                                        <Col sm={12} className='mt-1 mb-2'>
                                            <LabelWrapper label={t('Generate Prompt')} isShow={true} colorText="var(--vz-primary)">
                                                <Input
                                                    name="text"
                                                    type="textarea"
                                                    className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                                    placeholder=""
                                                    style={{ height: '200px' }}
                                                    value={condition?.generate_prompt}
                                                    onChange={(event: any) => {
                                                        const input = event.target.value;
                                                        setCondition((_prev: any) => ({ ..._prev, generate_prompt: input }))
                                                    }}
                                                    autoComplete="off"
                                                />
                                                <div className="w-100 mb-1 mb-xl-0 fs-12 text-muted pt-0">{t(`{today_kst}, {published_kst}, {published_line}, {keyword_info} will replace dynamically`)}</div>
                                            </LabelWrapper>
                                        </Col>

                                        <Col sm={12} className='mt-3 mb-1'>
                                            <LabelWrapper label={t('Check Prompt')} isShow={true} colorText="var(--vz-primary)">
                                                <Input
                                                    name="text"
                                                    type="textarea"
                                                    className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                                    placeholder=""
                                                    style={{ height: '200px' }}
                                                    value={condition?.check_prompt}
                                                    onChange={(event: any) => {
                                                        const input = event.target.value;
                                                        setCondition((_prev: any) => ({ ..._prev, check_prompt: input }))
                                                    }}
                                                    autoComplete="off"
                                                />
                                            </LabelWrapper>
                                        </Col>

                                        <Col sm={12} className='mt-3 mb-0'>
                                            <LabelWrapper label={t('Blocked Sites')} isShow={true} colorText="var(--vz-primary)">
                                                <Input
                                                    name="text"
                                                    type="textarea"
                                                    className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                                    placeholder=""
                                                    style={{ height: '200px' }}
                                                    value={condition?.blocked_sites}
                                                    onChange={(event: any) => {
                                                        const input = event.target.value;
                                                        setCondition((_prev: any) => ({ ..._prev, blocked_sites: input }))
                                                    }}
                                                    autoComplete="off"
                                                />
                                            </LabelWrapper>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Col>
                        )}
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <div className="d-flex justify-content-center align-item-center"></div>
                    <button
                        className="btn btn-primary"
                        type="button"
                        onClick={handleSave}
                        style={{ width: '120px' }}
                        disabled={isSaving}
                    >
                        {isSaving ? <Spinner size="sm" className="me-2" ></Spinner> : <></>}
                        {t("Button Save")}
                    </button>
                </ModalFooter>
            </Modal>
        </React.Fragment >
    );
};

export default ModalPrompt;